import { call } from 'redux-saga/effects';

import createWorker from 'app/redux/utils/create-worker';
import workInterval from 'app/redux/utils/work-interval';

import constants from 'app/constants/cache';

import blogAPI from 'app/api/blog';

const execute = function*() {
  return yield call(blogAPI.getAllBlogPosts);
};

export const {
  Actions,
  Generators,
  ReducerHandlers,
  Saga,
  Types,
  initState,
  localStateSelector,
  Selectors,
} = createWorker('blog/get-all', {
  localStateSelector: 'blogGetAll',
  execute,
  shouldWork: workInterval(constants.defaultUpdateIntervalInMilliseconds),
  takePolicy: 'latest',
});



// WEBPACK FOOTER //
// ./src/redux/blog/get-all/workers.js